// src/actions/reports/getVentasPorCategoria.action.ts
import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { VentasCategoriaInterface } from "../interfaces/ventasCategoria.interface";

export async function getVentasPorCategoriaAction(
  fechaInicio?: string,
  fechaFin?: string
): Promise<ApiResponse<VentasCategoriaInterface>> {
  const { data } = await apiClient.get<VentasCategoriaInterface>(
    "reports/ventas/categoria",
    { params: { fechaInicio, fechaFin } }
  );

  return {
    status: 200,
    data,
    message: "Ventas por categoría obtenidas correctamente",
  };
}